<template>
  <Popup :ref="(el) => popup = el"
         class="popup__lg"
         :title="helper.trans('labels.reattach_counterparty')"
         @onClose="hide"
  >
    <LoaderContent ref="loader" class="">
      <div class="" style="overflow: auto">
        <table class="table table-striped" style="position: relative">
          <thead>
          <tr>
            <th class="text-start p-sm">{{ helper.trans('labels.requisites') }}</th>
            <th class="text-start p-sm">{{ helper.trans('labels.currency') }}</th>
            <th class="text-start p-sm">{{ helper.trans('labels.holderName') }}</th>
            <th class="text-start p-sm">{{ helper.trans('labels.method') }}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(req, index) in availableRequisites" :key="index" class="">
            <td class="p-sm">{{ req.requisites }}</td>
            <td class="p-sm">{{ req.currency }}</td>
            <td class="p-sm">{{ req.holderName }}</td>
            <td class="p-sm">{{ helper.trans('pay_methods.' + req.method) }}</td>
            <td class="text-end p-sm">
              <button type="button" @click="selectRequisite(req.id)" class="btn btn-sm btn-outline-primary text-nowrap text-capitalize-first">
                {{ helper.trans('labels.select') }}
              </button>
            </td>
          </tr>
          <tr v-if="availableRequisites.length === 0">
            <td colspan="5" class="text-center py-5">
              {{ helper.trans('labels.no_available_requisites') }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </LoaderContent>
  </Popup>
</template>

<script lang="ts">
import {defineComponent, ref} from 'vue'
import {helper} from "@/service/CommonHelper";
import Popup from "@/apps/public/components/Popup.vue";
import LoaderContent from "@/apps/public/components/LoaderContent.vue";
import TraderRequisitesDTO from "@/models/TraderRequisitesDTO";

export default defineComponent({
  components: {
    LoaderContent,
    Popup,
  },
  emits: ['selected'],
  setup(props, {emit}) {
    const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
    const popup = ref<InstanceType<typeof Popup> | null>(null)
    const currentUserId = ref<string | null>(null)
    const availableRequisites = ref<TraderRequisitesDTO[]>([])

    const show = (userId: string, requisites: TraderRequisitesDTO[]) => {
      currentUserId.value = userId
      availableRequisites.value = requisites
      popup.value?.show()
    }

    const hide = () => {
      popup.value?.hide()
      currentUserId.value = null
      availableRequisites.value = []
    }

    const selectRequisite = (requisiteId: number) => {
      if (currentUserId.value) {
        emit('selected', currentUserId.value, requisiteId)
        hide()
      }
    }

    return {
      loader,
      popup,
      availableRequisites,
      show,
      hide,
      selectRequisite,
      helper
    }
  }
})
</script>
